import { apiHost, apiRoutes } from '@/config/routes'
import axios from 'axios'

const recaudosService = {}
const mode = process.env.VUE_APP_QUOTE_MODULE_MODE

recaudosService.listBanks = async (data) => {
    try {
      const headers = {
        accessToken: process.env.VUE_APP_CONSULT_SHIPPING_TOKEN
      }
      const url = mode === 'test' ? apiRoutes.recaudosListaBancosTest.route : apiRoutes.recaudosListaBancos.route
      const response = await axios.post(`${ apiHost }${ url }`, data, { headers })
      if (response.data && (response.data.codigoResultado === "0" || response.data.codigoResultado === 0)) {
        return response.data
      }
      return new Error(response.data.mensajeresultado)
    } catch (e) {
      return new Error(e)
    }
}

recaudosService.inscripcionRecaudo = async (data) => {
    try {
        const headers = {
          accessToken: process.env.VUE_APP_CONSULT_SHIPPING_TOKEN
        }
        const url = mode === 'test' ? apiRoutes.recaudosInscripcionTest.route : apiRoutes.recaudosInscripcion.route
        const response = await axios.post(`${ apiHost }${ url }`, data, { headers })
        if (response.data && (response.data.codigoResultado === "0" || response.data.codigoResultado === 0)) {
            return response.data
        }else{
            return response.data
        }
      } catch (e) {
        return new Error(e)
      }
}
recaudosService.consultaRemesaRecaudo = async (data) => {
  try {
    const headers = {
      accessToken: process.env.VUE_APP_CONSULT_SHIPPING_TOKEN
    }
    const url = mode === 'test' ? apiRoutes.recaudosConsultaMisPagosTest.route : apiRoutes.recaudosConsultaMisPagos.route
    const response = await axios.post(`${ apiHost }${ url }`, data, { headers })
    if (response.data && (response.data.codigoResultado === "0" || response.data.codigoResultado === 0)) {
        return response.data
    }else{
        return response.data
    }
  } catch (e) {
    return new Error(e)
  }
}
recaudosService.consultaClienteRecaudo = async (data) => {
  try {
    const url = mode === 'test' ? apiRoutes.recaudosConsultarClienteTest.route : apiRoutes.recaudosConsultarCliente.route
    const response = await axios.post(`${ apiHost }${ url }`, data)
    if (response.data && (response.data.codigoResultado === "0" || response.data.codigoResultado === 0)) {
        return response.data
    }else{
        return response.data
    }
  } catch (e) {
    return new Error(e)
  }
}

recaudosService.consultarListaRecaudos = async (data) => {
  try {
      const urlBase = mode === 'test' ? apiRoutes.consultarRecaudosProductosTest.route : apiRoutes.consultarRecaudosProductos.route;

      const body = {};
      if(data.Identificacion){
          body.document_number = data.Identificacion;
      }
      if(data.IdTipoIdentificacion){
          body.document_type = data.IdTipoIdentificacion;
      }
      if(data.social_reason){
          body.social_reason = data.social_reason;
      }
      if(data.start_date){
          body.start_date = data.start_date;
      }
      if(data.end_date){
          body.end_date = data.end_date;
      }
      if(data.page_size){
          body.page_size = data.page_size;
      }

      const response = await axios.post(`${apiHost}${urlBase}/search`, body);
      
      if (response.data && response.data.status_code === 200) {
          return response.data;
      } else {
          return response;
      }
  } catch (e) {
      return new Error(e);
  }
};
export default recaudosService